<template>
  <div class="foot1">
    <el-row class="companyData">
      <el-col :span="16" class="left">
        <div class="items">
          <p>区域找房</p>
          <ul>
            <li v-for="todo in areaData" @click="toquyusearch(todo.areaid)">
              {{ todo.name }}
            </li>
          </ul>
        </div>
        <div class="items">
          <p>客服电话</p>
          <span class="tel">+8621-33722221</span>
        </div>
        <div class="items">
          <p>意见反馈</p>
          <span>请添加右方官方微信客服</span>
        </div>
        <div class="foot2">
          <a target="_blank" href="https://beian.miit.gov.cn" class="foot3"
            >上海精寓实业有限公司沪ICP备17051552号-2</a
          >
          <!-- <span class="foot3" style="margin-top: 16px; margin-bottom: 20px"> -->
          <div class="beian">
            <img src="../assets/images/gongan.png" alt="" />
            <a
              class="foot3 filing"
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502004910"
              >沪公网安备31010502004910号</a
            >
          </div>

          <!-- </span> -->
        </div>
      </el-col>
      <el-col :span="8" class="right">
        <div class="qrcode">
          <span class="tips">扫码关注微信公众号</span>
          <img src="../assets/images/publicnumbercode.jpg" alt="" />
        </div>
        <div class="qrcode">
          <span class="tips">官方微信客服</span>
          <img src="../assets/images/weixincode.jpg" alt="" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import https from "../http.js";
import { getLoaction } from "../location.js";
export default {
  data() {
    return {
      areaData: [],
      currentCity: "",
      currentCityId: "",
    };
  },
  created() {
    console.log("foot");
    getLoaction.getLocationAddress().then((locationData) => {
      this.currentCity = locationData.ad_info.city;
      this.currentCityId = locationData.ad_info.cityCode;
      this.getAreaData();
    });
  },
  methods: {
    getAreaData() {
      var param = {
        cityId: this.currentCityId,
      };
      https
        .fetchPost("/wechat-index/get-district-list", param)
        .then((res) => {
          this.areaData = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toquyusearch(areaid) {
      this.$router.push({ path: "/HouseList", query: { areaid: areaid } });
      window.scrollTo(0, 0);
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* #app {
  position: relative;
} */
.foot1 {
  width: 100%;
  background: #1f2022;
  height: auto;
  /* position: absolute; */
  /* bottom: 0; */
}

.foot1 .companyData {
  width: 80%;
  margin: 0 auto;
  padding: 30px 0px;
}

.foot1 .companyData .items {
  margin-bottom: 16px;
  text-align: left;
}

.foot1 .companyData .items p {
  text-align: left;
  font-size: 18px;
  font-weight: 500;
  color: #696969;
}
.foot1 .companyData .items ul {
  display: flex;
  flex-wrap: wrap;
}

.items .tel {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
}

.items span {
  display: block;
}

.items li {
  margin-right: 10px;
  cursor: pointer;
}

.items li,
.items span {
  color: #fff;
  margin-top: 10px;
}

.foot1 .right {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.foot1 .right .qrcode {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.foot1 .right .tips {
  color: #fff;
  font-weight: 900;
  font-size: 18px;
}

.foot1 .right img {
  width: 140px;
  margin-top: 20px;
}

.foot2 {
  text-align: left;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
}
.foot2 .beian {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.foot2 img {
  width: 20px;
}
.foot3 {
  color: #ababab;
  text-decoration: none;
}
.foot3.filing {
  /* margin-top: 10px; */
}
</style>
